import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Button, Container, Row, Col } from 'react-bootstrap';
import { EyeFill, EyeSlashFill } from 'react-bootstrap-icons';
import { jwtDecode } from 'jwt-decode';

import { useUser } from './UserContext'; // 👈 importa il contesto


function LoginPage() {

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [group, setGroup] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const { setUsername: setCtxUsername, setRole } = useUser(); // 👈 funzioni per aggiornare contesto

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = new URLSearchParams();
    formData.append('username', username);
    formData.append('password', password);
    formData.append('group', group);

    const API_URL = process.env.REACT_APP_API_URL;

    try {
      const res = await fetch(`${API_URL}/token`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString(),
      });

      if (!res.ok) {
        throw new Error('Credenziali non valide o errore server');
      }

      const data = await res.json();
      localStorage.setItem('token', data.access_token);

      // Decodifica subito il token per aggiornare il contesto
      try {
        const decoded = jwtDecode(data.access_token);
        setCtxUsername(decoded.sub);
        setRole(decoded.role);
      } catch (err) {
        console.error('Errore decodifica token:', err);
      }

      navigate('/'); // torna alla home
    } catch (err) {
      alert(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="mt-5">
      <Row className="justify-content-md-center">
        <Col md={6}>
          <h3 className="mb-4 text-center">Login</h3>
          <Form onSubmit={handleSubmit} className="p-4 border rounded shadow-sm bg-light">
            
            {/* Dipartimento */}
            <Form.Group controlId="formGroup" className="mb-3">
              <Form.Label><strong>Dipartimento</strong></Form.Label>
              <Form.Select value={group} onChange={(e) => setGroup(e.target.value)} required>
                <option value="">-- Scegli un dipartimento --</option>
                <option value="elettrico">R&D - Elettrico</option>
                <option value="meccanico">R&D - Meccanico</option>
                <option value="admin">Admin</option>
              </Form.Select>
            </Form.Group>

            {/* Username */}
            <Form.Group controlId="formUsername" className="mb-3">
              <Form.Label><strong>Nome utente</strong></Form.Label>
              <Form.Control
                type="text"
                placeholder="Inserisci nome utente"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </Form.Group>

            {/* Password */}
            <Form.Group controlId="formPassword" className="mb-3" style={{ position: 'relative' }}>
              <Form.Label><strong>Password</strong></Form.Label>
              <Form.Control
                type={showPass ? 'text' : 'password'}
                placeholder="Inserisci password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                style={{ paddingRight: '2.5rem' }}
              />
              <span
                onClick={() => setShowPass(!showPass)}
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '38px',
                  cursor: 'pointer',
                  color: '#6c757d'
                }}
              >
                {showPass ? <EyeSlashFill size={20} /> : <EyeFill size={20} />}
              </span>
            </Form.Group>

            {/* Bottone Login */}
            <Row className="mt-4 mb-3">
              <Col className="text-center">
                <Button variant="primary" type="submit" size="lg" disabled={loading}>
                  {loading ? 'Accesso in corso...' : 'LOGIN'}
                </Button>
              </Col>
            </Row>

          </Form>
        </Col>
      </Row>
    </Container>
  );
}

export default LoginPage;
